import { Injectable, inject } from '@angular/core';
import { NgpToastManager, NgpToastOptions, NgpToastRef } from 'ng-primitives/toast';
import { Toast, ToastContext, ToastVariant } from '@ui/primitives/toast/toast';

export type NotificationOptions = Omit<NgpToastOptions<ToastContext>, 'context'> & {
  title?: string;
};

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly toastManager = inject(NgpToastManager);

  show(variant: ToastVariant, message: string, options?: NotificationOptions): NgpToastRef {
    const { title, ...toastOptions } = options ?? {};

    return this.toastManager.show(Toast, {
      ...toastOptions,
      context: { variant, title, message },
    });
  }

  success(message: string, options?: NotificationOptions): NgpToastRef {
    return this.show('success', message, options);
  }

  error(message: string, options?: NotificationOptions): NgpToastRef {
    return this.show('error', message, options);
  }

  info(message: string, options?: NotificationOptions): NgpToastRef {
    return this.show('info', message, options);
  }

  warning(message: string, options?: NotificationOptions): NgpToastRef {
    return this.show('warning', message, options);
  }

  neutral(message: string, options?: NotificationOptions): NgpToastRef {
    return this.show('neutral', message, options);
  }
}
